import { z } from 'my-zod'
import { vehicleSystemView } from './vehicle-system-view'
import { vehicleDispositionV2StatusEnum } from '../vehicle-disposition-v2/vehicle-dispositions-v2-model'

export const vehicleAdminView = vehicleSystemView.omit({
  customAssetFamilyId: true,
  outfitterCustomAssetSerialNumber: true
})

export type vehicleAdminView = z.infer<typeof vehicleAdminView>

export const vehicleWithDispositionAdminView = vehicleAdminView.augment({
  dispositionStatus: vehicleDispositionV2StatusEnum,
  modelFamilyName: z.string(),
  contractedPickupDateText: z.string().optional(),
  operatorName: z.string(),
  outfitterIndicatesPolarisApprovedWithoutRepairs: z.boolean(),
  dispositionShortId: z.string()
})

export type vehicleWithDispositionAdminView = z.infer<typeof vehicleWithDispositionAdminView>
